import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { STORAGE_KEYS } from '@/utils/constants'
import ru from '../locales/ru.json'
import en from '../locales/en.json'

const savedLanguage = localStorage.getItem(STORAGE_KEYS.LANGUAGE) || 'ru'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: savedLanguage,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
  })

// Сохраняем язык при изменении
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEYS.LANGUAGE, lng)
})

export default i18n
